import * as React from 'react';

export const LazyInvestmentGoalsQuestionnaireStep = React.lazy(() => import('./component'));

export * from './utils';
